module.exports = __webpack_public_path__ + "static/media/29FUNOV13.8b8e05d4.jpg";